module.exports = __webpack_public_path__ + "img/headache.ac810453.png";